import React, {useEffect, useMemo} from 'react'
import _ from 'lodash'
import {useGetGroupActionFields} from '../../../state/groups/get-group-action-fields/hooks'
const Action = ({action}) => {
  const {action_id, entity_id} = action
  const {state: groupActionFields, call: callGetGroupActionFields} = useGetGroupActionFields()

  useEffect(() => {
    if (!!action_id && !!entity_id) {
      callGetGroupActionFields({group_id: entity_id, action_id: action_id, all_fields: true})
    }
  }, [action_id, entity_id, callGetGroupActionFields])

  const info = useMemo(() => {
    if (_.isEmpty(action)) return []

    if (_.isEmpty(groupActionFields.data)) return []
    // fetch closed fields
    let _closefields = _.toArray(groupActionFields.data)[0].filter(f => !f.is_open_field)
    let _openfields = _.toArray(groupActionFields.data)[0].filter(f => f.is_open_field)

    const _data =
      action?.values.reduce(
        (t, v) => ({
          ...t,
          [v.key]: v.value,
        }),
        {}
      ) || {}

    let rets = [
      {
        name: action.name,
        fields: _openfields.map(f => ({field_name: f.name, value: _data[f.key]})),
      },
    ]

    const returnName = action.change_return_name ? action.return_name : `Return ${action.name}`

    // map items
    rets = [
      ...rets,
      {
        name: returnName,
        fields: _closefields.map(f => ({field_name: f.name, value: _data[f.key]})),
      },
    ]
    return rets
  }, [action, groupActionFields])

  return (
    <>
      {_.map(info, (d, i) => (
        <div key={i} className="ap-mb-28">
          <p className="tab-label tab-top-label ap-m-0 ap-pb-1 ap-mb-2 ap-bb ap-b-gray-light ap-typography ap-typography--sm">
            {d.name}
          </p>
          {d.fields.map((item, i) => {
            let val =
              typeof item.value === 'object' && !!item.value ? item.value.display_name : item.value

            return (
              <div key={i} className="ap-mb-28">
                <p className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                  {item.field_name}
                </p>
                {!_.isNil(val) && (
                  <p className="tab-label-value ap-m-0 ap-typography ap-typography--sm">{val}</p>
                )}
                {_.isNil(val) && (
                  <p className="tab-label-value ap-m-0 ap-typography ap-typography--sm ap-typography--gray">
                    n/a
                  </p>
                )}
              </div>
            )
          })}
        </div>
      ))}
    </>
  )
}

export default Action
